import { MENTION_BLOT_NAME } from "constants/unifyNotes";

type QuillDeltaOp = { insert?: unknown };

export const extractMentionedProfileIds = (delta: { ops?: QuillDeltaOp[] }) => {
  const mentionedIds = (delta?.ops ?? [])
    .map((op) => {
      const insert = op.insert;
      const isMentionInsert =
        insert && typeof insert === "object" && MENTION_BLOT_NAME in insert;
      if (!isMentionInsert) return undefined;
      return (insert as Record<string, { id?: string }>)[MENTION_BLOT_NAME]?.id;
    })
    .filter((id): id is string => Boolean(id));

  return Array.from(new Set(mentionedIds));
};
